import {
    SET_LOGIN_SUCCESSS,
    SET_LOGIN_API,
    GET_LOGIN_API
} from './types'

const setLoginAPI = (values) => {
    return {
        type: SET_LOGIN_API,
        values
    }
}

const setLoginSuccess = (values) => {
    return {
        type: SET_LOGIN_SUCCESSS,
        values
    }
}

const getLoginAPI = (values) =>{
    return {
        type: GET_LOGIN_API,
        values
    }
}
export {
    setLoginAPI,
    setLoginSuccess,
    getLoginAPI
}
